import React from 'react';
import {
  CreditCard, UserPlus, Wallet, AlertTriangle,
  Trophy, Target, Sparkles, Star, Bell,
  Check, Trash2,
} from 'lucide-react';

export const getNotifIcon = (type) => {
  const icons = {
    transaction: <CreditCard size={16} className="text-green-400" />,
    withdrawal: <Wallet size={16} className="text-amber-400" />,
    user: <UserPlus size={16} className="text-blue-400" />,
    scraper_error: <AlertTriangle size={16} className="text-red-400" />,
    prediction_hit_3: <Trophy size={16} className="text-yellow-400" />,
    prediction_hit_2: <Sparkles size={16} className="text-purple-400" />,
    prediction_hit_1: <Target size={16} className="text-cyan-400" />,
    high_confidence_alert: <Star size={16} className="text-blue-400 animate-pulse" />,
  };
  return icons[type] || <Bell size={16} className="text-gray-400" />;
};

export const getNotifStyle = (type, read) => {
  if (read) return 'bg-gray-800/30';
  const styles = {
    prediction_hit_3: 'bg-gradient-to-r from-yellow-900/40 to-orange-900/30 border-l-4 border-yellow-500',
    prediction_hit_2: 'bg-gradient-to-r from-purple-900/30 to-pink-900/20 border-l-4 border-purple-500',
    prediction_hit_1: 'bg-gradient-to-r from-cyan-900/30 to-blue-900/20 border-l-4 border-cyan-500',
    high_confidence_alert: 'bg-gradient-to-r from-blue-900/50 to-indigo-900/40 border-l-4 border-blue-500 animate-pulse',
  };
  return styles[type] || 'bg-gray-800/50';
};

export const getTimeAgo = (dateStr) => {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  if (diffMins < 1) return 'Ahora';
  if (diffMins < 60) return `Hace ${diffMins} min`;
  if (diffHours < 24) return `Hace ${diffHours}h`;
  if (diffDays < 7) return `Hace ${diffDays}d`;
  return date.toLocaleDateString('es-DO');
};

export const NotificationItem = ({ notification, onMarkRead, onDelete }) => (
  <div
    onClick={() => !notification.read && onMarkRead(notification.id)}
    className={`flex items-start gap-3 px-4 py-3 border-b border-gray-800/50 cursor-pointer transition-colors group ${getNotifStyle(notification.type, notification.read)}`}
    data-testid={`notification-${notification.id}`}
  >
    <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${
      notification.type === 'prediction_hit_3' ? 'bg-yellow-500/20 ring-2 ring-yellow-500'
      : notification.type === 'prediction_hit_2' ? 'bg-purple-500/20'
      : notification.type === 'prediction_hit_1' ? 'bg-cyan-500/20'
      : notification.read ? 'bg-gray-800' : 'bg-gray-800/80'
    }`}>
      {getNotifIcon(notification.type)}
    </div>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2">
        <p className={`text-sm font-medium truncate ${
          notification.type === 'prediction_hit_3' ? 'text-yellow-400'
          : notification.type === 'prediction_hit_2' ? 'text-purple-400'
          : notification.type === 'prediction_hit_1' ? 'text-cyan-400'
          : notification.read ? 'text-gray-400' : 'text-white'
        }`}>{notification.title}</p>
        <span className={`w-2 h-2 rounded-full flex-shrink-0 transition-opacity ${
          notification.read ? 'opacity-0' : 'opacity-100'
        } ${
          notification.type === 'prediction_hit_3' ? 'bg-yellow-400'
          : notification.type === 'prediction_hit_2' ? 'bg-purple-400'
          : notification.type === 'prediction_hit_1' ? 'bg-cyan-400'
          : 'bg-amber-400'
        }`} />
      </div>
      <p className="text-xs text-gray-500 line-clamp-2 mt-0.5">{notification.message}</p>
      <p className="text-xs text-gray-600 mt-1">{getTimeAgo(notification.created_at)}</p>
    </div>
    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
      {!notification.read && (
        <button onClick={(e) => { e.stopPropagation(); onMarkRead(notification.id); }}
          className="p-1.5 rounded hover:bg-gray-700 text-gray-400 hover:text-green-400" title="Marcar como leida">
          <Check size={14} />
        </button>
      )}
      <button onClick={(e) => onDelete(notification.id, e)}
        className="p-1.5 rounded hover:bg-gray-700 text-gray-400 hover:text-red-400" title="Eliminar">
        <Trash2 size={14} />
      </button>
    </div>
  </div>
);
